import React, { PropsWithChildren } from 'react';
import { PlaceWithFilters } from 'features/insights/store/poi/poi-types';
import { Accordion, FlexContainer, Icon, Thumbnail } from '@placer-ui/components';
import { ReportOptionKey } from 'features/explore/components/explore-side-bar/components/explore-drawer/drawer-options';
import { getFeatureFlags } from 'core/flow-control';
import classNames from 'classnames';
import styles from './explore-drawer-option.module.scss';

const ICON_TYPES = {
    property: 'Property',
    nearby_activity: 'MapPinArea',
    market: 'Market',
    enclosed_poi: 'Property',
    chain: 'Chain',
};

export type ExploreDrawerOptionProps = {
    poi?: PlaceWithFilters;
    onActivate?: () => void;
    isActive?: boolean;
    title: string;
    subtitle: string;
    testId?: string;
    value: ReportOptionKey;
};

export const ExploreDrawerOption = ({
    isActive,
    title,
    subtitle,
    testId,
    children,
    onActivate,
    value,
}: PropsWithChildren<ExploreDrawerOptionProps>) => {
    const { accesibility_enable_explore_property_reports_ff } = getFeatureFlags();
    const onClick = () => {
        !isActive && onActivate && onActivate();
    };

    if (accesibility_enable_explore_property_reports_ff) {
        return (
            <Accordion
                testId={testId}
                onOpenChange={onClick}
                items={[
                    {
                        label: title,
                        description: subtitle,
                        value,
                        Content: (
                            <FlexContainer className={styles.container} flexDirection="column">
                                {children}
                            </FlexContainer>
                        ),
                        Icon: <Thumbnail size="small" src={<Icon type={ICON_TYPES[value]} />} />,
                    },
                ]}
            />
        );
    }

    return (
        <div
            className={classNames(styles.exploreDrawerOption, {
                [styles.isButton]: !isActive,
                [styles.isSelected]: isActive,
            })}
            data-testid={testId}
            onClick={onClick}
        >
            <div className={styles.description}>
                <div className={styles.title}>{title}</div>
                <div className={styles.subtitle}>{subtitle}</div>
            </div>
            {isActive && <div className={styles.actions}>{children}</div>}
        </div>
    );
};
